import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const AccountManagerWrapper = styled.div`
  background-color: #402680;
  padding: 20px 15px;
  border-radius: 8px;
  margin: 30px -20px;
  padding: 15px;
  box-shadow: 0 0 15px #dcdcdc;

  ${mediaMaxWidth.phone`
    margin: 25px -20px;
  `}
`;

export const AccountManagerInfo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const AccountManagerAvatar = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const AccountManagerPersonalInfo = styled.div`
  padding: 0 15px;
  display: flex;
  flex: 3;
  flex-direction: column;
`;

export const AccountManagerImg = styled.img`
  width: 65px;
  height: 65px;
  object-fit: cover;
  border-radius: 50%;
  margin: 0 5px;
  overflow: hidden;

  ${mediaMaxWidth.phone`
    width: 50px;
    height: 50px;
  `}
`;

export const AccountManagerName = styled.div`
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 10px;
  color: #fff;

  ${mediaMaxWidth.phone`
    font-size: 1em;
  `}
`;

export const AccountManagerCompany = styled.div`
  font-size: 0.9em;
  font-weight: 500;
  margin-bottom: 15px;
  color: #fff;

  ${mediaMaxWidth.phone`
    font-size: 0.8em;
  `}
`;

export const AccountManagerMessage = styled.div`
  width: 65px;
  height: 65px;
  margin: 0 10px 0 auto;
  display: flex;

  ${mediaMaxWidth.phone`
    width: 50px;
    height: 50px;
  `}
`;

export const MessageLink = styled.a`
  height: 100%;
  width: 100%;
  background: #79D9D9;
  border-radius: 50%;
  transition: 0.1s ease-in-out;

  svg {
    margin: 19px 16px;
    color: #fff;
    font-size: 1.8em;

    ${mediaMaxWidth.phone`
      margin: 10px 8px;
    `}
  }

  &:hover {
    cursor: pointer;
    background: #fff;

    svg {
      color: #402680;
    }
  }
`;
